import { Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { ProductScope, ProductService, RoutingService } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { ComponentService } from 'src/app/service/component.service';

@Injectable({
  providedIn: 'root',
})
export class PDPAuthGuard {
  constructor(
    private productService: ProductService,
    private routingService: RoutingService,
    private componentService: ComponentService
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.routingService.getRouterState().pipe(
      map((state) => state.nextState.params.productCode),
      switchMap((productCode: string) => {
        // if open pdp from smartedit
        if (!productCode) {
          return of(true);
        }

        return this.productService.get(productCode, ProductScope.DETAILS).pipe(
          filter(Boolean),
          map((product: any) => {
            if (product.baseProdCategory === '' || typeof product.baseProdCategory === 'undefined') {
              // if no base product category, redirect to product not found page
              this.routingService.goByUrl('/product-not-found');
              return false;
            } else {
              this.componentService.setResetMOQAddCart(true);
              if (!product.baseProduct && product.variantOptions) {
                this.productService
                  .get(product.variantOptions[0].code, ProductScope.DETAILS)
                  .pipe(filter(Boolean), take(1))
                  .subscribe((prod: any) => {
                    this.updateMinOrderQuantity(prod.minOrderQuantity);
                    this.routingService.go({
                      cxRoute: 'product',
                      params: prod,
                    });
                  });
                return false;
              } else {
                this.updateMinOrderQuantity(product.minOrderQuantity);
                return true;
              }
            }
          })
        );
      })
    );
  }

  updateMinOrderQuantity(minOrderQuantity: any) {
    if (minOrderQuantity && minOrderQuantity > 0) {
      this.componentService.setResetPdpQty(minOrderQuantity);
    } else {
      this.componentService.setResetPdpQty(1);
    }
  }
}
